/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown> }} Calendar_Day_SelectedInputs */

const fr_calendar_day_selected = /** @type {(inputs: Calendar_Day_SelectedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.date}, sélectionné`)
};

const en_calendar_day_selected = /** @type {(inputs: Calendar_Day_SelectedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.date}, selected`)
};

/**
* | output |
* | --- |
* | "{date}, selected" |
*
* @param {Calendar_Day_SelectedInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const calendar_day_selected = /** @type {((inputs: Calendar_Day_SelectedInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Calendar_Day_SelectedInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_calendar_day_selected(inputs)
	return fr_calendar_day_selected(inputs)
});